import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Dishwasher = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M3.666 6.635h4.667v2a2.333 2.333 0 1 1-4.667 0v-2Zm.667.666v1.334a1.667 1.667 0 1 0 3.333 0V7.3H4.333Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M6.333 10.3v3h-.667v-3h.667Z" fillRule="evenodd" clipRule="evenodd" />
      <path d="M4.332 12.635h3.333v.666H4.332v-.666Z" fillRule="evenodd" clipRule="evenodd" />
      <path
        d="M.666 1.635h14.666v14H.666v-14Zm.667.666v12.667h13.333V2.3H1.333Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M15 4.635H1V3.97h14v.666Z" fillRule="evenodd" clipRule="evenodd" />
      <path
        d="M11.666 4.302V1.969h.667v2.333h-.667ZM11.94 8.112l-.275.19-.274-.19.274-.397.275.397Zm-.275.799c-.066.106-.139.225-.211.35a6.6 6.6 0 0 0-.327.629c-.093.21-.128.349-.128.411a.667.667 0 1 0 1.333 0c0-.062-.035-.2-.128-.411a6.6 6.6 0 0 0-.327-.629 12.199 12.199 0 0 0-.212-.35Zm0-.61-.274-.19v.002l-.003.004-.01.013a10.909 10.909 0 0 0-.149.225c-.095.147-.223.35-.352.572-.128.22-.26.465-.36.695-.095.215-.185.465-.185.68a1.333 1.333 0 1 0 2.667 0c0-.215-.09-.465-.185-.68-.1-.23-.232-.474-.36-.695a13.612 13.612 0 0 0-.47-.748l-.032-.05-.009-.012-.002-.004-.001-.001-.275.19Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

Dishwasher.category = 'product-category';

Dishwasher.displayName = 'Dishwasher';
